module.exports = __webpack_public_path__ + "static/img/application_4.414f99c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/main/application/application_4.jpg
// module id = lfRR
// module chunks = 1